module.exports = __webpack_public_path__ + "img/1111.c344c517.png";